<template>
    <p class="wizard-box-nr">
        {{ this.header_step }}/{{ this.total_steps }}
    </p>
</template>

<script>
    export default {
        props: ['step', 'header_step', 'user'],

        data() {
            return {
                total_steps: this.isAgency() ? 8 : 9
            }
        },

        methods: {
            isAgency() {
                return (this.user !== null && !(window.location.href.includes('customer')))
            }
        }
    }
</script>
